export default __webpack_public_path__ + "static/media/PendingUnitsOrangeIcon.166cb4d0.png";